import axios from 'axios'

const baseUrl = 'api/patents'

export function getPatentJurisdictions(entityId, params) {
    return axios.get(`${baseUrl}/entities/${entityId}/jurisdictions/aggregate?${params}`)
}

export function getPatentAggregate(entityId, params) {
    return axios.get(`${baseUrl}/entities/${entityId}/aggregate?${params}`)
}

export function getPatentCount(entityId) {
    return axios.get(`${baseUrl}/entities/${entityId}/count`)
}

export function getPatentThresholds(entityId, params) {
    return axios.get(`${baseUrl}/entities/${entityId}/claim_scores/thresholds/aggregate?${params}`)
}

export function getPatentPowerScores(entityId, sectorId) {
    return axios.get(`${baseUrl}/entities/${entityId}/powerscore/sectors/${sectorId}/`)
}

export function patentSearchAsync(params) {
    return axios.get(`${baseUrl}/search_async`, {
        params: params,
    })
}

export function patentSearch(params) {
    return axios.get(`${baseUrl}/search`, {
        params: params,
    })
}
